import * as PropTypes from 'prop-types'

const JobsShape = PropTypes.shape({

})

export { JobsShape }
